<template>
  <div class="custom-modal-backdrop">
    <div class="modal-card">

      <!-- STAGE 1: VERIFY -->
      <form v-if="!verified" @submit.prevent="verify">
        <h4>Verify Your Identity</h4>

        <input class="form-control mb-2"
          v-model="form.idNumber"
          placeholder="ID Number"
          required />

        <input class="form-control mb-2"
          v-model="form.memberNumber"
          placeholder="Member Number"
          required />

        <input class="form-control mb-3"
          type="date"
          v-model="form.dob"
          required />

        <button class="btn btn-primary w-100" :disabled="loading">
          Verify
        </button>
      </form>

      <!-- STAGE 2: ACTIVATE -->
      <div v-else>
        <div class="alert alert-success">
          Hi <b>{{ fullName }}</b> 👋<br />
          Welcome to <b>Finsis – ConIT Microfinance System</b><br />
          Please enter your email to activate or change your account password.
        </div>

        <form @submit.prevent="activate">
          <input
            type="email"
            class="form-control mb-3"
            v-model="email"
            placeholder="Enter your email"
            required
          />

          <button class="btn btn-success w-100">
            Activate Account
          </button>
        </form>
      </div>

      <button class="btn btn-link mt-3 w-100" @click="$emit('close')">
        Close
      </button>

    </div>
  </div>
</template>

<script>
  import { userService } from "@/api/user.service";

export default {
  data() {
    return {
      loading: false,
      verified: false,
      fullName: "",
      email: "",

      form: {
        idNumber: "",
        memberNumber: "",
        dob: ""
      }
    };
  },

  methods: {
    async verify() {
      this.loading = true;
      try {
        const res = await userService.verifyClient({
          idNumber: this.form.idNumber,
          memberNumber: this.form.memberNumber,
          dob: this.form.dob
        });

        this.fullName = res.fullName;
        this.verified = true;
      } catch (e) {
        alert(e.response?.data?.message || "Verification failed");
      } finally {
        this.loading = false;
      }
    },

    async activate() {
      try {
        await userService.activateClient({
          idNumber: this.form.idNumber, // 🔑 THIS IS THE KEY
          email: this.email
        });

        alert("Activation email sent. Please check your inbox.");
        this.$emit("close");
      } catch (e) {
        alert(e.response?.data?.message || "Activation failed");
      }
    }
  }
};
</script>

<style scoped>
.custom-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  animation: popIn 0.25s ease-out;
}

@keyframes popIn {
  from {
    transform: scale(0.95) translateY(10px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
</style>
